import moment from 'moment';
import { QRCodeSVG } from 'qrcode.react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import './device-page.scss';

import { useDeviceQRStore } from '~modules/device/model/use-device-qr.ts';
import { config } from '~shared/config';
import { Preloader } from '~shared/ui';

export function DevicePage() {
	const { number } = useParams<{ number: string }>();
	const { qr, connect, disconnect, time, tick, device } = useDeviceQRStore();

	useEffect(() => {
		if (number) connect(number, true);

		const intervalId = setInterval(() => {
			tick();
		}, 1000);

		return () => {
			disconnect();
			clearInterval(intervalId);
		};
	}, [number, connect, disconnect]);

	return (
		<div className="device-page">
			{!qr ? (
				<Preloader />
			) : (
				<>
					<h1>
						{device?.section?.title}: {device?.number}
					</h1>
					<QRCodeSVG value={qr} />
					<h2>{moment(time).format('DD.MM.YYYY HH:mm:ss')}</h2>
					<h3>Отсканируйте QR или откройте приложение по ссылке {config.smenaUrl}</h3>
					<QRCodeSVG className="small" value={config.smenaUrl} />
				</>
			)}
		</div>
	);
}
